import React, { useEffect, useState } from 'react';
import './style.css';
import { useNavigate } from 'react-router-dom';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
import img_artho_logo from '../images/arthro-logo.png';

const Navbar = ({ data, loader }) => {
  const [isActive, setIsActive] = useState(false);
  const [mobilePackageOpen, setMobilePackageOpen] = useState(false);
  const [mobileAcademicsOpen, setMobileAcademicsOpen] = useState(false);

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const updateWindowSize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener('resize', updateWindowSize);
    window.addEventListener('load', updateWindowSize);

    return () => {
      window.removeEventListener('resize', updateWindowSize);
      window.removeEventListener('load', updateWindowSize);
    };
  }, []);

  useEffect(() => {
    const nav = document.querySelector('.menus');
    if (!nav) return;
    nav.style.transition = '0.5s';
    nav.style.clipPath = 'inset(0 0 0 100%)';
    if (isActive) {
      nav.style.transition = '1s';
      nav.style.clipPath = 'inset(0 0 0 0)';
    }
  }, [isActive]);

  const navigate = useNavigate();

  const movePage = (path) => {
    setIsActive(false);
    if (loader) loader(true);
    setTimeout(() => {
      navigate(path);
    }, 500);
  };

  const chengRouts = (routs) => {
    if (loader) loader(true);
    setTimeout(() => {
      navigate(routs);
    }, 500);
  };

  const media = () => {
    setIsActive(false);
    if (loader) loader(true);
    setTimeout(() => {
      navigate('/media');
    }, 500);
  };

  return (
    <div className='navbarMain'>
      <div className='mainNav col-11 m-auto d-flex align-items-center justify-content-between p-2 my-3'>
        <div className='d-flex align-items-center'>
          <div style={{ width: '80px', height: '45px', marginLeft: '20%' }}>
            <img onClick={() => chengRouts('/')} src={img_artho_logo} style={{ width: '100%', height: '100%', cursor: 'pointer', objectFit: 'contain' }} alt="ARTHRO3D Logo" />
          </div>
        </div>
        <div className='navPc'>
          <div className='d-flex align-items-center'>
            <div className='d-flex gap-4 align-items-center'>
              <p style={{ cursor: 'pointer', color: '#66707A', fontSize: '16px', margin: 0 }} onClick={() => chengRouts('/')}>About ARTHRO3D</p>
              <p style={{ cursor: 'pointer', color: '#66707A', fontSize: '16px', margin: 0 }} onClick={() => chengRouts('/ai-3d-robotics')}>AI &amp; 3D Robotics</p>

              {/* Our Packages Dropdown */}
              <div className='nav-dropdown-container'>
                <p className='nav-dropdown-trigger'>
                  Our Packages <FaChevronDown style={{ fontSize: '11px', marginTop: '2px' }} />
                </p>
                <div className='nav-dropdown-menu'>
                  <div className='nav-dropdown-item' onClick={() => chengRouts('/package-robo-core')}>
                    <span>ARTHRO3D ROBO Core</span>
                    <FaChevronRight className='chevron-icon' />
                  </div>
                  <div className='nav-dropdown-item' onClick={() => chengRouts('/package-robo-xr')}>
                    <span>ARTHRO3D ROBO XR (Single User)</span>
                    <FaChevronRight className='chevron-icon' />
                  </div>
                  <div className='nav-dropdown-item' onClick={() => chengRouts('/package-robo-xr-pro')}>
                    <span>ARTHRO3D ROBO XR PRO (Multi User)</span>
                    <FaChevronRight className='chevron-icon' />
                  </div>
                  <div className='nav-dropdown-item' onClick={() => chengRouts('/package-simulation-lab')}>
                    <span>ARTHRO3D ROBO SIMULATION LAB</span>
                    <FaChevronRight className='chevron-icon' />
                  </div>
                </div>
              </div>

              {/* Academics Dropdown */}
              <div className='nav-dropdown-container'>
                <p className='nav-dropdown-trigger'>
                  Academics <FaChevronDown style={{ fontSize: '11px', marginTop: '2px' }} />
                </p>
                <div className='nav-dropdown-menu' style={{ width: '200px' }}>
                  <div className='nav-dropdown-item' onClick={() => chengRouts('/study-materials')}>
                    <span>Study materials</span>
                    <FaChevronRight className='chevron-icon' />
                  </div>
                  <div className='nav-dropdown-item' onClick={() => chengRouts('/fellowships')}>
                    <span>Fellowships</span>
                    <FaChevronRight className='chevron-icon' />
                  </div>
                  <div className='nav-dropdown-item' onClick={() => chengRouts('/blogs')}>
                    <span>Blogs</span>
                    <FaChevronRight className='chevron-icon' />
                  </div>
                  <div className='nav-dropdown-item' onClick={() => chengRouts('/publications')}>
                    <span>Publications</span>
                    <FaChevronRight className='chevron-icon' />
                  </div>
                </div>
              </div>

              <p style={{ cursor: 'pointer', color: '#66707A', fontSize: '16px', margin: 0 }} onClick={() => chengRouts('/media')}>Media</p>
              <p style={{ cursor: 'pointer', color: '#66707A', fontSize: '16px', margin: 0 }} onClick={() => chengRouts('/contact')}>Contact Us</p>
            </div>
          </div>
        </div>

        <div className='navPc'>
          <div className='d-flex align-items-center px-2'>
            <div className='buttonDiv' onClick={() => chengRouts('/surgeon-center')}>
              <div className='button'>Surgeon's Center</div>
              <div className='button-clip'>Surgeon's Center</div>
            </div>
          </div>
        </div>

        <div className='navMobile'>
          <div className={isActive ? 'hamburger is-active' : 'hamburger'} id="hamburger" onClick={() => setIsActive(!isActive)}>
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </div>
        </div>
      </div>

      <div className='menus d-flex justify-content-center align-items-center' style={{ width: '100%', height: '110vh', position: 'fixed', top: '0', right: '0', zIndex: '1', background: 'linear-gradient(to left , rgb(207, 207, 207), rgb(230, 230, 230),rgb(240, 240, 240))' }}>
        <div className='d-grid gap-3'>
          <p style={{ cursor: 'pointer', fontWeight: '600', fontSize: '25px', color: '#66707A' }} onClick={() => movePage('/')}>About ARTHRO3D</p>
          <p style={{ cursor: 'pointer', fontWeight: '600', fontSize: '25px', color: '#66707A' }} onClick={() => movePage('/ai-3d-robotics')}>AI &amp; 3D Robotics</p>

          <div>
            <p
              style={{ cursor: 'pointer', fontWeight: '600', fontSize: '25px', color: '#66707A', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
              onClick={() => setMobilePackageOpen(!mobilePackageOpen)}
            >
              Our Packages <FaChevronDown style={{ fontSize: '18px', transition: '0.3s transform', transform: mobilePackageOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} />
            </p>
            {mobilePackageOpen && (
              <div className='mobile-dropdown-menu my-2'>
                <p style={{ cursor: 'pointer', fontWeight: '500', fontSize: '18px', color: '#475569' }} onClick={() => movePage('/package-robo-core')}>ARTHRO3D ROBO Core</p>
                <p style={{ cursor: 'pointer', fontWeight: '500', fontSize: '18px', color: '#475569' }} onClick={() => movePage('/package-robo-xr')}>ARTHRO3D ROBO XR (Single User)</p>
                <p style={{ cursor: 'pointer', fontWeight: '500', fontSize: '18px', color: '#475569' }} onClick={() => movePage('/package-robo-xr-pro')}>ARTHRO3D ROBO XR PRO (Multi User)</p>
                <p style={{ cursor: 'pointer', fontWeight: '500', fontSize: '18px', color: '#475569' }} onClick={() => movePage('/package-simulation-lab')}>ARTHRO3D ROBO SIMULATION LAB</p>
              </div>
            )}
          </div>

          <div>
            <p
              style={{ cursor: 'pointer', fontWeight: '600', fontSize: '25px', color: '#66707A', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
              onClick={() => setMobileAcademicsOpen(!mobileAcademicsOpen)}
            >
              Academics <FaChevronDown style={{ fontSize: '18px', transition: '0.3s transform', transform: mobileAcademicsOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} />
            </p>
            {mobileAcademicsOpen && (
              <div className='mobile-dropdown-menu my-2'>
                <p style={{ cursor: 'pointer', fontWeight: '500', fontSize: '18px', color: '#475569' }} onClick={() => movePage('/study-materials')}>Study materials</p>
                <p style={{ cursor: 'pointer', fontWeight: '500', fontSize: '18px', color: '#475569' }} onClick={() => movePage('/fellowships')}>Fellowships</p>
                <p style={{ cursor: 'pointer', fontWeight: '500', fontSize: '18px', color: '#475569' }} onClick={() => movePage('/blogs')}>Blogs</p>
                <p style={{ cursor: 'pointer', fontWeight: '500', fontSize: '18px', color: '#475569' }} onClick={() => movePage('/publications')}>Publications</p>
              </div>
            )}
          </div>

          <p style={{ cursor: 'pointer', fontWeight: '600', fontSize: '25px', color: '#66707A' }} onClick={media}>Media</p>
          <p style={{ cursor: 'pointer', fontWeight: '600', fontSize: '25px', color: '#66707A' }} onClick={() => movePage('/contact')}>Contact Us</p>

          <div className='buttonDiv m-auto' onClick={() => movePage('/surgeon-center')}>
            <div className='button'>Surgeon's Center</div>
            <div className='button-clip'>Surgeon's Center</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;